/**
 * Admin-access predicate (AUTH-CHAT-WIRING-CONTRACT §2.2).
 *
 * `usePermissions()` returns the union of the identity's role names AND its
 * granular grant keys (the AUTH lane's `getPermissions` change). The Admin area
 * (nav group + the Permissions route) is shown only when the caller holds either
 * the `admin` role or one of the three admin grant keys. This mirrors the
 * server-side `requirePermissionKey('admin:users'|'admin:roles'|'admin:permissions')`
 * guards for VISIBILITY only — the backend stays authoritative (it still 403s the
 * API for non-admins).
 */

/** The three granular admin grants the Admin area gates on. */
export const ADMIN_PERMISSION_KEYS = [
  "admin:users",
  "admin:roles",
  "admin:permissions",
] as const;

/** True when `perms` grants admin access (the `admin` role or any admin grant). */
export function hasAdminAccess(perms: string[] | undefined): boolean {
  if (!perms) return false;
  return (
    perms.includes("admin") ||
    perms.some((p) => (ADMIN_PERMISSION_KEYS as readonly string[]).includes(p))
  );
}
